import styled, { css } from 'styled-components';
import { colors } from '../../../utils/colors';

export type InputProps = {
  type?: string;
  erro?: boolean;
};
export const Containerdiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${colors.branco};
  padding: 30px;
  border-radius: 15px;
`;

export const Title = styled.div<{ primary?: boolean }>`
  color: ${colors.verde};
  font-weight: 700;

  ${(props) =>
    props.primary &&
    css`
      font-size: 20px;
      margin-bottom: 25px;
    `}
`;

export const ContDiv = styled.div`
  min-height: 40px;
  display: flex;
  flex-direction: row;
`;

export const ContainerColumn = styled.div<{ primary?: boolean; secondary?: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${(props) =>
    props.primary &&
    css`
      padding: 0;
      width: 30%;
    `}

  ${(props) =>
    props.secondary &&
    css`
      margin: 5px;
      width: 70%;
    `}
`;

export const SelectContainer = styled.select`
  width: 100%;
  min-height: 35px;
  padding-left: 5px;
  color: ${colors.verde};
  border: 1px solid ${colors.verde30};
  border-radius: 10px;
`;

export const InputContainer = styled.input<InputProps>`
  width: 100%;
  min-height: 35px;
  padding-left: 5px;
  color: ${colors.verde};
  border: 1px solid ${colors.verde30};
  border-radius: 10px;

  &:focus {
    outline: none;
    background-color: ${colors.verde30};
  }
  ${(props) =>
    props.erro &&
    css`
      border: 1px solid red;
      &:focus {
        outline: none;
        border: 1px solid red;
      }
    `}
`;
